import React, { FC } from 'react';
import ColumnItemImportPlaceholderDropZone from './ColumnItemImportPlaceholderDropZone';
import Borders from './Borders';
import * as Styled from './styles';

interface IProps {
    blockIndex: string;
    columnIdx: string;
}

const ColumnItemPlaceholder: FC<IProps> = ({ blockIndex, columnIdx }) => (
    <Styled.PlaceholderDiv>
        <Borders />
        <Styled.ItemDiv />
        <ColumnItemImportPlaceholderDropZone
            blockIndex={blockIndex}
            columnIdx={columnIdx}
        />
    </Styled.PlaceholderDiv>
);

export default ColumnItemPlaceholder;
